// Production endpoint
export const endpoint = "https://jewasity-prod-server.jewasity.com";
// Development endpoints (commented out)
// export const endpoint = "http://54.91.91.58:4000";
// export const endpoint = "http://localhost:3002";
